export enum CoverageInfoModalVersion {
  V1 = "v1",
  V2 = "v2",
}
